// extracted by mini-css-extract-plugin
export default {"link":"Section_link__zwcy4"};